import {Modal} from 'antd';
import React, {useEffect, useState} from 'react';

import {selectMetadata, loadMetadata, resetMetadata} from 'entities/metadata';
import {selectEntityData, resetLoadedData} from 'modules/data';
import {loadDummyData} from 'modules/data/data-actions';
import {IListGridEntityData} from 'modules/data/data-types';
import {ReactComponent as CloseIcon} from 'shared/assets/close.svg';
import {EEntityType} from 'shared/constants/entities';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectModalData, TModalComponentInterface} from 'store/slices/modals-slice';

import {ListGrid} from '../list-grid';
import {Spinner} from '../spinner';

import './list-grid-modal.less';

export interface IListGridProps extends TModalComponentInterface {
}

export const ListGridModal = ({onClose}: IListGridProps) => {
    const dispatch = useAppDispatch();
    const modalData = useAppSelector(state => selectModalData(state));
    const entityName = modalData?.entityName || '';

    const data = useAppSelector(
        state => selectEntityData(entityName, EEntityType.LIST_GRID)(state) as IListGridEntityData,
    );
    const meta = useAppSelector(state => selectMetadata(entityName, EEntityType.LIST_GRID)(state));
    const [loading, setIsLoading] = useState(false);

    useEffect(() => {
        (async () => {
            if (!meta) {
                setIsLoading(true);
                await dispatch(loadMetadata(entityName, EEntityType.LIST_GRID));
                setIsLoading(false);
            }

            if (!data) {
                setIsLoading(true);
                await dispatch(loadDummyData(entityName, EEntityType.LIST_GRID, 'lists'));
                setIsLoading(false);
            }
        })();
        return () => {
            dispatch(resetLoadedData(entityName, EEntityType.LIST_GRID));
            dispatch(resetMetadata({
                entityType: EEntityType.LIST_GRID,
                loading: false,
                entityName: entityName || '',
            }));
        };
    }, []);

    return (
        <Modal
            className="list-grid-modal"
            footer={null}
            visible
            centered
            width={meta?.width || 680}
            onCancel={onClose}
            maskClosable={false}
            title={meta?.title}
            closeIcon={<CloseIcon className="list-modal__close-icon" />}
        > {!loading && data?.lists
                ? (
                    <ListGrid
                        data={data?.lists}
                        meta={meta}
                    />
                ) : <div className="list-modal__spinner"><Spinner /></div>}
        </Modal>
    );
};
